import type { PublicationStatus } from '@/domain/ids';

/** Content shown to children. Drafts and reviews stay hidden until published. */
export const VISIBLE_STATUSES: readonly PublicationStatus[] = ['published'];

/** Whether to show the "sample content awaiting validation" notice. */
export const SHOW_CONTENT_STATUS = import.meta.env.VITE_SHOW_CONTENT_STATUS !== 'false';
